let checkdusbam = 'polrestacilacap-app.ezgate.co.id'; // buat local
let baseurl_api = 'https://api.dev.ezgate.co.id/';
let tenantName = 'dusbam';

// === local ===
if (checkdusbam) {
    const tenant = checkdusbam.split('-app.ezgate.co.id')[0];
    tenantName = tenant;
    baseurl_api = `https://${tenant}-api.dev.ezgate.co.id/`;
}

// === development ===
const currentHost = window.location.hostname;
if (currentHost.includes('-app.dev.ezgate.co.id')) {
    tenantName = currentHost.split('-app.dev.ezgate.co.id')[0];
    baseurl_api = `https://${tenantName}-api.dev.ezgate.co.id/`;
} else if (currentHost.includes('localhost')) {
    tenantName = 'polrestacilacap';
}

export const environment = {
    production: false,
    https: 'https://',
    baseurl_api: baseurl_api,
    tenant: tenantName,
    baseurlStorage: 'https://ezgate.co.id/api_dev/',
    pathImg: '',
    path: '',
    auth: 'api/v1/auth/login',
    register: 'register',
    token: '',
    refresh_token: 'auth/refresh',
    img_default:
        'https://zeus.awh.co.id/awh_pos/images/k4m3dNY7iv416BvZCtKgMsagFVlI6kHTVIpcq8TiA-AhZlmGJYgTV4PBHHTiGDk9JLzi9Lh6kfGcirloU39_xfJcfF7FsDol4NmfI-IjzLUyerd7uXyZkaFuaEYGbITi',
    mqtt: {
        username: 'dhivapos',
        password: 'FurlaRasaMelon2024',
    },
};
